import DatePickerV1 from "../../../../components/form_builder/elements/date_picker/DatePickerV1.vue";
import { validateRequired, validateDate } from "../../../../helpers/validation";
import { formatDateOnly } from "../../../../helpers/date";

export default {
    componentName: "fb-date-picker-v1",
    component: DatePickerV1,
    defaultAttrs: {
        properties: {
            label: "Label",
            description: "",
            value: "",
            required: false,
            hidden: false,
            readonly: false,
            minValue: "",
            maxValue: "",
            style: {},
            eFormEditable: true,
            resetStoreValues: false,
            dependentProperties: {}
        }
    },
    gridAttrs: {
        type: "template",
        width: 120,
        template: ({ value }) => (value ? formatDateOnly(value) : "")
    },
    getValueReport: (value) => {
        return value ? formatDateOnly(value) : "";
    },
    validate: ({ value, properties }) => {
        const errors = [];
        if (properties.required && !validateRequired(value))
            errors.push("This field is required");
        if (value && !validateDate(value))
            errors.push("This field must have a valid date format");
        if(properties.minValue)
            if (value && value < properties.minValue)
                errors.push(
                    `This date must be greater than ${properties.minValue}`
                );
        if(properties.maxValue)
            if (value && value > properties.maxValue)
                errors.push(`This date must be less than ${properties.maxValue}`);
        return errors;
    }
};
